var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-config-layer"}},[_vm._v(" 安全配置 ")])}
var staticRenderFns = []

export { render, staticRenderFns }